import React, { useEffect, useState } from 'react';
import "./ControlPannel.css";
import swal from "sweetalert";

import Input from "../../Components/Input/Input";
import Modal from '../../Components/Modal/Modal';
import Message from '../../Components/Message/Message';
import DropDown from '../../Components/DropDown/DropDown';

import { GrTextAlignRight } from "react-icons/gr";
import { MdDeleteForever, MdLayers } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import { useTranslation } from 'react-i18next';

import { SwatchesPicker } from 'react-color';


import {
	add_config,
	get_config,
	delete_config,
	get_prix_vente_toggle,
	set_prix_vente_toggle
} from "../../context/Services/Settings";
import { isHex } from "../../utils/Helper";
import packageJson from '../../../package.json';

const EmptyData = () => {
	return (
		<div>
			no data
		</div>
	)
}

const ControlPannel = () => {
	const { t } = useTranslation();

	const [payload, setPayload] = useState({});
	const [config, setConfig] = useState({
		STATUSES: [],
		CATEGORIES: [],
		MODE_REGLEMENTS: [],
		LIVRAISON_RETOUR: [],
	});

	const [show, setShow] = useState({
		status: false,

	});

	const [loading, setLoading] = useState(true);
	const [loader, setLoader] = useState(false);

	// Prix de vente toggle state
	const [prixVenteEnabled, setPrixVenteEnabled] = useState(false);
	const [prixVenteLoading, setPrixVenteLoading] = useState(false);

	const handle_get_config = () => {
		get_config("all")
			.then(res => {
				setConfig(res?.data);
				setLoading(false)
			})
			.catch(e => {
				console.log(e);
				setLoading(false);
			})
	}

	const handle_get_prix_vente_toggle = () => {
		get_prix_vente_toggle()
			.then(res => {
				setPrixVenteEnabled(res?.data?.enabled || false);
			})
			.catch(e => {
				console.log(e);
			})
	}

	const handle_toggle_prix_vente = async () => {
		setPrixVenteLoading(true);
		try {
			const newValue = !prixVenteEnabled;
			await set_prix_vente_toggle(newValue);
			setPrixVenteEnabled(newValue);
		} catch (e) {
			console.log(e);
		} finally {
			setPrixVenteLoading(false);
		}
	}

	const handle_open_modal = (type) => {
		setShow({
			status: true,
			type: type
		})
	}

	const handle_edit_modal = (type, data) => {
		setShow({
			status: true,
			type: type
		})

		setPayload(data)
	}

	const handle_change = (key, value) => {
		setPayload(prev => ({
			...prev,
			[key]: value
		}))
	}

	const handle_close = () => {
		setShow({
			status: false,
			type: ""
		});
		setPayload({})
	}

	const handle_add = () => {

		setLoader(true);
		add_config({ payload: payload, config: show?.type })
			.then(res => {
				handle_close();
				setTimeout(() => {
					handle_get_config();
					setLoader(false);
				}, [])
			})
			.catch(e => {
				console.log(e);
				setLoader(false);
			})
	}

	const handle_delete = async (value_id, config) => {
		const willDelete = await swal({
			title: "Es-vous sûr ?",
			text: t("Est ce que vous voulez vraiment supprimer ?"),
			icon: "warning",
			buttons: true,
			dangerMode: true,
		});

		if (willDelete) {
			delete_config({ value_id: value_id, config: config })
				.then(res => {
					handle_close();
					setTimeout(() => {
						handle_get_config();
						setLoader(false);
					}, [])
				})
				.catch(e => {
					console.log(e);
					setLoader(false);
				})
		}
	}


	useEffect(() => {
		setLoading(true);
		handle_get_config();
		handle_get_prix_vente_toggle();
	}, [])

	return (
		<>
			<Message loading={loader} status={{ status: loader }} />

			<Modal
				showBakcDrop={show.status}
				modal={show.status}
				hideModal={handle_close}
			>
				<div className='full'>

					{
						show?.type === 'color' &&
						<div className="flex flex-col gap">
							<Input
								placeholder="color"
								setChange={(e) => handle_change("value", e)}
								value={payload?.value}
							/>
							<div className="color_picker flex gap justify-center" style={{ borderRadius: "10px" }}>
								<input
									type="color"
									id="color"
									name="colors"
									value={payload?.value}
									onChange={(e) => handle_change("value", e.target.value)}
								/>
							</div>
							<div className="color_picker flex gap justify-center" style={{ borderRadius: "10px" }}>
								<SwatchesPicker onChange={(e) => handle_change("value", e.hex)} />
							</div>
						</div>
					}

					{
						(show?.type === 'size') &&
						<Input
							icon={<GrTextAlignRight className="icon_m" />}
							placeholder="..."
							setChange={(e) => handle_change("value", e)}
							value={payload?.value}
						/>
					}

					{
						show?.type === 'sub_category' &&
						<div className="full flex flex-col gap">
							<div className='relative full'>
								<DropDown
									fullWidth={true}
									customButtonStyle="justify-start category_dropdown"
									button={
										<>
											<MdLayers />
											<b>Select categories</b>
											<IoMdArrowDropdown className="to-right" />
										</>
									}
								>
									{
										config?.CATEGORIES.map(elem => (
											<>
												<div className='drop_item' onClick={() => handle_change("category_id", elem?._id)}>
													{elem?.value}
												</div>
												<div className='splitter'></div>
											</>
										))
									}
								</DropDown>
							</div>
							<Input
								icon={<GrTextAlignRight className="icon_m" />}
								placeholder="..."
								setChange={(e) => handle_change("value", e)}
								value={payload?.value}
							/>
						</div>
					}

					{
						(show?.type === 'status' || show?.type === 'category' || show?.type === 'mode_reglement' || show?.type === 'livraison_retour') &&
						<div className="flex flex-col gap_5">
							<Input
								icon={<GrTextAlignRight className="icon_m" />}
								placeholder="..."
								setChange={(e) => handle_change("value", e)}
								value={payload?.value}
							/>
							<div className="color_picker flex gap">
								<input
									type="color"
									id="color"
									name="colors"
									value={payload?.bg_color}
									onChange={(e) => handle_change("bg_color", e.target.value)}
								/>
								<label htmlFor="color">{t("Background color")}</label>
							</div>
							<div className="color_picker flex gap">
								<input
									type="color"
									id="color_text"
									name="color_text"
									value={payload?.text_color}
									onChange={(e) => handle_change("text_color", e.target.value)}
								/>
								<label htmlFor="color_text">{t("Text color")}</label>
							</div>
						</div>
					}

				</div>
				<button className="filter_button full pointer" onClick={handle_add}>
					<b>{t("Save")}</b>
				</button>
			</Modal>

			<div className="flex flex-col gap" style={{ gap: '30px' }}>
				{/* Prix de Vente Toggle Section */}
				<div className="flex flex-col" style={{ gap: "10px" }}>
					<span className="flex items-center gap">
						<h5>{t("Prix de Vente - Paramètres")}</h5>
					</span>
					<div className="flex items-center gap" style={{ padding: "15px", backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
						<div className="flex flex-col" style={{ flex: 1 }}>
							<b>{t("Autoriser la vente en dessous du prix de vente")}</b>
							<p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
								{t("Si activé, les commerciaux peuvent vendre en dessous du prix de vente minimum défini pour chaque produit")}
							</p>
						</div>
						<label className="toggle_switch">
							<input
								type="checkbox"
								checked={prixVenteEnabled}
								onChange={handle_toggle_prix_vente}
								disabled={prixVenteLoading}
							/>
							<span className="toggle_slider"></span>
						</label>
					</div>
				</div>

				{/* Statuses Section */}
				<div className="flex flex-col" style={{ gap: "10px" }}>
					<span className="flex items-center gap">
						<h5>{t("Statuses")}</h5>
						<span className="size_style flex justify-center items-center add_size_btn" onClick={() => handle_open_modal("status")}>
							+
						</span>
					</span>
					<div className="flex gap wrap_line">
						{
							!loading && config?.STATUSES.length === 0
								? <EmptyData />
								: config?.STATUSES.map((elem) => (
									<div className="flex gap_5">
										<span
											onClick={() => handle_edit_modal("status", { value: elem?.value, _id: elem?._id, text_color: elem?.text_color, bg_color: elem?.bg_color })}
											className="nugget_status pointer"
											style={{ backgroundColor: elem?.bg_color, color: elem?.text_color, borderRadius: "5px" }}
										>
											{elem?.value}
										</span>

										<span className="delete_icon flex justify-center items-center" onClick={() => handle_delete(elem?._id, "status")}>
											<MdDeleteForever />
										</span>
									</div>
								))
						}
					</div>
				</div>

				{/* Stock Categories Section */}
				<div className="flex flex-col" style={{ gap: "10px" }}>
					<span className="flex items-center gap">
						<h5>{t("Catégories de Stock")}</h5>
						<span className="size_style flex justify-center items-center add_size_btn" onClick={() => handle_open_modal("category")}>
							+
						</span>
					</span>
					<div className="flex gap wrap_line">
						{
							!loading && (!config?.CATEGORIES || config?.CATEGORIES.length === 0)
								? <EmptyData />
								: config?.CATEGORIES?.map((elem) => (
									<div className="flex gap_5" key={elem?._id}>
										<span
											onClick={() => handle_edit_modal("category", { value: elem?.value, _id: elem?._id, text_color: elem?.text_color, bg_color: elem?.bg_color })}
											className="nugget_status pointer"
											style={{ backgroundColor: elem?.bg_color, color: elem?.text_color, borderRadius: "5px" }}
										>
											{elem?.value}
										</span>

										<span className="delete_icon flex justify-center items-center" onClick={() => handle_delete(elem?._id, "category")}>
											<MdDeleteForever />
										</span>
									</div>
								))
						}
					</div>
				</div>

				{/* Livraison / Retour Labels Section */}
				<div className="flex flex-col" style={{ gap: "10px" }}>
					<span className="flex items-center gap">
						<h5>{t("Livraison / Retour")}</h5>
						<span className="size_style flex justify-center items-center add_size_btn" onClick={() => handle_open_modal("livraison_retour")}>
							+
						</span>
					</span>
					<div className="flex gap wrap_line">
						{
							!loading && (!config?.LIVRAISON_RETOUR || config?.LIVRAISON_RETOUR.length === 0)
								? <EmptyData />
								: config?.LIVRAISON_RETOUR?.map((elem) => (
									<div className="flex gap_5" key={elem?._id}>
										<span
											onClick={() => handle_edit_modal("livraison_retour", { value: elem?.value, _id: elem?._id, text_color: elem?.text_color, bg_color: elem?.bg_color })}
											className="nugget_status pointer"
											style={{ backgroundColor: elem?.bg_color, color: elem?.text_color, borderRadius: "5px" }}
										>
											{elem?.value}
										</span>

										<span className="delete_icon flex justify-center items-center" onClick={() => handle_delete(elem?._id, "livraison_retour")}>
											<MdDeleteForever />
										</span>
									</div>
								))
						}
					</div>
				</div>

								{/* Mode de Règlement Section */}
				<div className="flex flex-col" style={{ gap: "10px" }}>
					<span className="flex items-center gap">
						<h5>{t("Modes de Règlement")}</h5>
						<span className="size_style flex justify-center items-center add_size_btn" onClick={() => handle_open_modal("mode_reglement")}>
							+
						</span>
					</span>
					<div className="flex gap wrap_line">
						{
							!loading && (!config?.MODE_REGLEMENTS || config?.MODE_REGLEMENTS.length === 0)
								? <EmptyData />
								: config?.MODE_REGLEMENTS?.map((elem) => (
									<div className="flex gap_5" key={elem?._id}>
										<span
											onClick={() => handle_edit_modal("mode_reglement", { value: elem?.value, _id: elem?._id, text_color: elem?.text_color, bg_color: elem?.bg_color })}
											className="nugget_status pointer"
											style={{ backgroundColor: elem?.bg_color, color: elem?.text_color, borderRadius: "5px" }}
										>
											{elem?.value}
										</span>

										<span className="delete_icon flex justify-center items-center" onClick={() => handle_delete(elem?._id, "mode_reglement")}>
											<MdDeleteForever />
										</span>
									</div>
								))
						}
					</div>
				</div>

				{/* Version Section */}
				<div style={{
					marginTop: "20px",
					padding: "15px",
					backgroundColor: "#f9fafb",
					borderRadius: "8px",
					border: "1px solid #e5e7eb",
					textAlign: "center"
				}}>
					<p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
						{t("Version")} <strong style={{ color: "#374151" }}>{packageJson.version}</strong>
					</p>
				</div>
			</div>

			<style jsx>{`
				.toggle_switch {
					position: relative;
					display: inline-block;
					width: 50px;
					height: 26px;
				}
				.toggle_switch input {
					opacity: 0;
					width: 0;
					height: 0;
				}
				.toggle_slider {
					position: absolute;
					cursor: pointer;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background-color: #ccc;
					transition: .4s;
					border-radius: 26px;
				}
				.toggle_slider:before {
					position: absolute;
					content: "";
					height: 20px;
					width: 20px;
					left: 3px;
					bottom: 3px;
					background-color: white;
					transition: .4s;
					border-radius: 50%;
				}
				input:checked + .toggle_slider {
					background-color: #7983ff;
				}
				input:checked + .toggle_slider:before {
					transform: translateX(24px);
				}
				input:disabled + .toggle_slider {
					opacity: 0.6;
					cursor: not-allowed;
				}
			`}</style>
		</>
	)
}

export default ControlPannel